import { render, staticRenderFns } from "./DeviceType.vue?vue&type=template&id=563d931a&"
import script from "./DeviceType.vue?vue&type=script&lang=js&"
export * from "./DeviceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeviceType.vue"
export default component.exports